import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  ListItem,
  OrderedList,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export function NoVersionsNote() {
  const { t } = useTranslation();
  return (
    <Alert status="info" alignItems="flex-start">
      <AlertIcon />
      <Box>
        <AlertTitle>{t('inquiry.noVersionConfigured')}</AlertTitle>
        <AlertDescription>
          <OrderedList spacing={1}>
            <ListItem>{t('inquiry.noVersionStep1')}</ListItem>
            <ListItem>{t('inquiry.noVersionStep2')}</ListItem>
            <ListItem>{t('inquiry.noVersionStep3')}</ListItem>
          </OrderedList>
        </AlertDescription>
      </Box>
    </Alert>
  );
}
